import { render, staticRenderFns } from "./VOption.vue?vue&type=template&id=66e7dee6&"
import script from "./VOption.vue?vue&type=script&lang=js&"
export * from "./VOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports